import { AInput } from "@/admin/form/Fields.tsx";
import { updateVmLimitsMutation } from "@/admin/settings/settingsQuery.ts";
import { controllerProps } from "@/components/forms/ariaController.tsx";
import { WModalForm } from "@/components/forms/WModalForm.tsx";
import { WTextField } from "@/components/forms/WTextField.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import type { AdminVmLimits } from "@warrenio/api-spec/spec.oats.gen";
import type { ReactNode } from "react";
import { Controller, type SubmitHandler, useForm } from "react-hook-form";

interface VmLimitsModalProps {
    value: number;
    title: string;
    limits: AdminVmLimits;
    type: string;
}

interface VmLimitsButtonProps extends VmLimitsModalProps {
    button: ReactNode;
}

export function VmLimitsButton(props: VmLimitsButtonProps) {
    return (
        <WModal button={props.button}>
            <VmLimitsModalContent {...props} />
        </WModal>
    );
}

interface VmLimitsInputs {
    current: string;
}

function VmLimitsModalContent(props: VmLimitsModalProps) {
    const { value, title, type, limits } = props;
    const updateMutation = useStandardMutation(updateVmLimitsMutation);

    const onSubmit: SubmitHandler<VmLimitsInputs> = async (inputs) => {
        const { current } = inputs;

        await updateMutation.mutateAsync({
            body: { ...limits, [type]: Number(current) },
        });
    };

    const form = useForm<VmLimitsInputs>({
        mode: "onBlur",
        reValidateMode: "onBlur",

        defaultValues: {
            current: value ? String(value) : "",
        },
    });

    const { control } = form;

    return (
        <WModalForm title={`Update ${title}`} label="Update" form={form} onSubmit={onSubmit}>
            <Controller
                control={control}
                name="current"
                {...controllerProps({ isRequired: true })}
                render={({ field }) => (
                    <WTextField autoFocus headless block label={title} value={field.value} onChange={field.onChange}>
                        <AInput />
                    </WTextField>
                )}
            />
        </WModalForm>
    );
}
